import { CmsObjectWithDefault } from '@components/Cms/types';

// Todo: Fix naming convention of each key, either follow camelCase or PascalCase
export type CaptchaFormInputCmsKey = 'completeCaptcha' | 'pleaseReload' | 'cannotLoadCaptcha' | 'clickToSolveCaptcha';
export const CaptchaFormInputCms: CmsObjectWithDefault<CaptchaFormInputCmsKey> = {
    clickToSolveCaptcha: {
        cmsId: 282759,
        defaultTranslation: 'Click to solve captcha',
    },
    completeCaptcha: {
        cmsId: 67538,
        defaultTranslation: 'Please complete the captcha (above).',
    },
    pleaseReload: {
        cmsId: 67674,
        defaultTranslation: 'Click here to reload the captcha.',
    },
    cannotLoadCaptcha: {
        cmsId: 67673,
        defaultTranslation: "We weren't able to load the captcha test required to complete this form.",
    },
};
